<template lang="pug">
//- ПРИМЕР ИСПОЛЬЗОВАНИЯ
//- parallax-image-wrapper(
//-   src="https://phonoteka.org/uploads/posts/2021-07/1625633666_32-phonoteka-org-p-raian-gosling-draiv-art-krasivo-35.jpg"
//-   :speed="200"
//-   :size="140"
//- )
//-  template(#default)
//-    div.white--text.full-width.d-flex.justify-center РАЙАН ГОСЛИНГ В ФИЛЬМЕ "ДРАЙВ"

.parallax__wrapper(
  :style="`--height: ${preparedHeight}; --width: ${preparedWidth}`"
)
  .parallax__image(
    ref="parallaxBg"
    :style="`--size: ${size}%; background-image: url(${src})`"
  )
  .parallax__inner-content
    slot
</template>

<script>
export default {
  name: 'ParallaxImageWrapper',

  props: {
    src: {
      type: String,
      required: true,
    },
    speed: {
      type: Number,
      default: 50,
    },
    size: {
      type: Number,
      default: 110,
    },
    height: {
      type: [String, Number],
      default: 900,
    },
    width: {
      type: [String, Number],
      default: 'auto',
    },
  },

  computed: {
    preparedHeight() {
      return Number.isInteger(this.height)
        ? `${this.height}px`
        : this.height;
    },
    preparedWidth() {
      return Number.isInteger(this.width)
        ? `${this.width}px`
        : this.width;
    },
  },

  mounted() {
    window.addEventListener('mousemove', this.mouseMoveHandler);
  },

  beforeDestroy() {
    window.removeEventListener('mousemove', this.mouseMoveHandler);
  },

  methods: {
    mouseMoveHandler(e) {
      const { parallaxBg } = this.$refs;
      if (parallaxBg) {
        const x = e.clientX / window.innerWidth;
        const y = e.clientY / window.innerHeight;
        const { width, height } = parallaxBg.getBoundingClientRect();
        const movementY = (height / this.size) * 100 + y * this.speed >= height ? height - (height / this.size) * 100 : y * this.speed;
        const movementX = (width / this.size) * 100 + x * this.speed >= width ? width - (width / this.size) * 100 : x * this.speed;
        parallaxBg.style.transform = `translate(-${movementX}px, -${movementY}px)`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.parallax {
  &__wrapper {
    height: var(--height);
    min-width: var(--width);
    position: relative;
    overflow: hidden;
  }
  &__image {
    position: absolute;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    width: var(--size);
    height: var(--size);
    transition: all 0.1s ease-out;
  }
  &__inner-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
}
</style>
